import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const PaymentSuccess = () => {
  const [loading, setLoading] = useState(true);
  const [sessionInfo, setSessionInfo] = useState(null);
  const [error, setError] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  // Get session_id from query string
  const sessionId = new URLSearchParams(location.search).get("session_id");

  useEffect(() => {
    const fetchSession = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/provider/payment-success?session_id=${sessionId}`);

        if (!res.ok) {
          throw new Error("Failed to fetch payment details");
        }

        const data = await res.json();
        setSessionInfo(data);
      } catch (error) {
        console.error("Error fetching payment success info:", error);
        setError("Could not verify payment details.");
      } finally {
        setLoading(false);
      }
    };

    if (sessionId) {
      fetchSession();
    } else {
      setError("No session ID found in URL");
      setLoading(false);
    }
  }, [sessionId]);

  if (loading) {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
      <i className="fas fa-spinner fa-spin fa-3x text-primary mb-3"></i>
      <p className="h5">Verifying your payment...</p>
    </div>
  );
}

  if (error) return <p className="text-danger">{error}</p>;

  setTimeout(() => {
  // window.location.href = "/provider/panel/payment";
  navigate("/provider/panel/payment");
}, 3000);

  // console.log("session", sessionInfo);

  return (
    <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
        <div className="ps-2 ps-lg-4">
          <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
            Payment Success
          </h4>
      {sessionInfo ? (
        <>
          <div className="text-center mt-5">
      <i className="fas fa-check-circle fa-3x text-success mb-3"></i>
      <h4>Payment verified successfully!</h4>
      <p>Redirecting to your dashboard...</p>
    </div>
        </>
      ) : (
        <p>No payment details available.</p>
      )}
    </div>
  </div>
  );
};

export default PaymentSuccess;
